import { FullscreenDialog } from './FullscreenDialog';
import { peekContentKey, usePeek } from '../hooks/usePeek';
import { ReconstructedDocumentContent } from '../pages/ReconstructedDocumentView';
import { DocumentContent } from '../pages/DocumentView';
import { DocumentPageContent } from '../pages/DocumentPageView';

// Renders the active peek (?peek=<type>:<id>) in the shared FullscreenDialog.
// Content only mounts when its type matches, so a closed peek fetches nothing.
export function PeekHost() {
  const { peek, closePeek } = usePeek();
  return (
    <FullscreenDialog open={!!peek} onClose={closePeek}>
      {peek?.type === 'reconstructed' && (
        <ReconstructedDocumentContent key={peekContentKey(peek)} id={peek.id} embedded />
      )}
      {peek?.type === 'document' && (
        <DocumentContent key={peekContentKey(peek)} id={peek.id} embedded onClose={closePeek} />
      )}
      {peek?.type === 'page' && (
        <DocumentPageContent key={peekContentKey(peek)} id={peek.id} embedded onClose={closePeek} />
      )}
    </FullscreenDialog>
  );
}
